import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { DocumentePublice, DocumentePubliceEditPayload } from './documente-publice.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DocumentePubliceService {
    private token!: string;
    private httpOptions: any;
    private basePath = environment.interop.basePath;

    private getDocumentePubliceUrl = this.basePath + environment.interop.platform.nomenclatoare.documentePublice.getDocumente;
    private storeDocumentePubliceUrl = this.basePath + environment.interop.platform.nomenclatoare.documentePublice.storeDocument;
    private deleteDocumentePubliceUrl = this.basePath + environment.interop.platform.nomenclatoare.documentePublice.deleteDocument;
    private getDocumentePubliceActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.documentePublice.getDocumenteActive;
    private getDocumentePublicePublicUrl = this.basePath + environment.interop.platform.nomenclatoare.documentePublice.getDocumentePublic;
    private updateDocumentePubliceUrl = this.basePath + environment.interop.platform.nomenclatoare.documentePublice.updateDocumente;
    private updateOrderUrl = this.basePath + environment.interop.platform.nomenclatoare.documentePublice.updateOrder;
    private changeStatusActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.documentePublice.changeStatusDocumenteActive;
    private changeStatusPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.documentePublice.changeStatusDocumentePublic;
    private fileUploadUrl = this.basePath + environment.interop.platform.nomenclatoare.documentePublice.fileUpload;

    constructor(private http: HttpClient) { }

    storeDocument(data: DocumentePublice) {
        return this.http.post(this.storeDocumentePubliceUrl, data, this.httpOptions);
    }

    getDocumente() {
        return this.http.get(this.getDocumentePubliceUrl, this.httpOptions);
    }

    getDocumenteActive() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.getDocumentePubliceActiveUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get documente publice active:', error);
                    return throwError(error);
                })
            );
    }

    getDocumentePublic() {
        return this.http.get(this.getDocumentePublicePublicUrl, this.httpOptions);
    }

    updateDocument(data: DocumentePubliceEditPayload) {
        return this.http.put(this.updateDocumentePubliceUrl, data, this.httpOptions);
    }

    deleteDocument(id: number) {
        return this.http.delete(this.deleteDocumentePubliceUrl + id, this.httpOptions);
    }

    updateOrder(id: number, data: any) {
        return this.http.post(this.updateOrderUrl + id, data, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }

    fileUpload(formData: FormData) {
        return this.http.post<{ data: any }>(this.fileUploadUrl, formData);
    }
}
